import { ADMIN_USERS_FORM } from './index';
import { Action } from '../action';

export class AdminUsersFormInitAction implements Action {
	readonly type = ADMIN_USERS_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersFormDestroyAction implements Action {
	readonly type = ADMIN_USERS_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersFormClickSubmitAction implements Action {
	readonly type = ADMIN_USERS_FORM.CLICK_SUBMIT;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminUsersFormUpdateAction implements Action {
	readonly type = ADMIN_USERS_FORM.UPDATE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminUsersFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_USERS_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminUsersFormUpdateFailureAction implements Action {
	readonly type = ADMIN_USERS_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
